import { enumUIModes } from "../constants";
import { Globals } from "../CoreApp/Globals";

export function isInPlanning() {
  return Globals._uiConfig.GetUIMode() === enumUIModes.planning;
}
